export const ResultsStoreModule = async (storeKey = "questions_results") => {
  const STORE_KEY = storeKey
  let results = localStorage.getItem(STORE_KEY)

  const init = async (afterInitCb = () => {}) => {
    try {
      results = await getStore(STORE_KEY)
      if (results === null) await setResults()
      return afterInitCb()
    } catch (e) {
      console.log("[init] error", e)
      if (results === null) await setResults()
      return afterInitCb()
    }
  }

  const saveAnswer = (questionId, answer) => {
    if (questionId) {
      const updatedResults = { ...results, [questionId]: answer }
      return setResults(updatedResults)
    }
  }

  const setResults = (updatedResults = {}) => {
    return new Promise((resolve, reject) => {
      try {
        localStorage.setItem(STORE_KEY, JSON.stringify(updatedResults))
        results = JSON.parse(localStorage.getItem(STORE_KEY))
        window.dispatchEvent(new Event("storage"))
        resolve(results)
      } catch (error) {
        console.log("[setResults] error", error)
        reject(error)
      }
    })
  }

  const getStore = (storeName) => {
    return new Promise((resolve, reject) => {
      try {
        let data = localStorage.getItem(storeName)
        data ? resolve(JSON.parse(data)) : resolve({})
      } catch (e) {
        console.log("[getStore] error", e)
        reject(e.message)
      }
    })
  }

  const getResultByQuestionId = (questionId) => {
    if (questionId) return results[questionId]
  }

  return {
    init,
    saveAnswer,
    getResultByQuestionId,
    getStore,
    setResults,
    STORE_KEY,
  }
}
